import { OrderPIIRouteService } from 'common/data';
import { BaseService } from 'core/services';

class OrderPIIService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new OrderPIIRouteService());
	}
	checkIfOrderAddressPIIExistsAsync(id, isFulfillmentOrder, isView, orderId) {
		var url = this.routeService.checkIfOrderAddressPIIExistsAsync(id, isFulfillmentOrder, isView, orderId);
		return this.apiClient.post(url);
	}
}

export default OrderPIIService;



// WEBPACK FOOTER //
// ./src/common/data/services/OrderPIIService.js